import { useState } from "react";
import { X, Mail, Lock, User as UserIcon, LogIn, Phone } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/auth/AuthContext";
import { toast } from "sonner";

export default function AuthModal({ open, onClose }) {
  const { setUser } = useAuth();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const url = mode === "login" ? "/auth/login" : "/auth/register";
      const body = mode === "login" ? { email, password } : { email, phone, password, name };
      const r = await api.post(url, body);
      if (mode === "register" && r.data.status === "pending") {
        toast.success("Registo enviado! Aguarda aprovação do admin antes de poderes entrar.");
        setMode("login");
      } else {
        setUser(r.data);
        toast.success(mode === "login" ? "Bem-vindo de volta!" : "Conta criada!");
        onClose();
      }
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : Array.isArray(d) ? d.map(e => e.msg).join(", ") : "Erro");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[110] bg-black/80 backdrop-blur-md flex items-center justify-center p-4" onClick={onClose} data-testid="auth-modal">
      <div className="glass max-w-md w-full p-8 relative" onClick={e => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-[color:var(--text-2)] hover:text-gold" data-testid="auth-close"><X size={20}/></button>
        <h2 className="font-display text-4xl mb-2 text-center">{mode === "login" ? "Entrar" : "Criar conta"}</h2>
        <p className="text-center text-[color:var(--text-2)] text-sm mb-6">Bem-vindo ao Triunfo de Gaia</p>

        <form onSubmit={submit} className="space-y-3">
          {mode === "register" && (
            <div className="relative">
              <UserIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--text-3)]" size={16}/>
              <input className="input pl-9" placeholder="Nome" value={name} onChange={e=>setName(e.target.value)} required data-testid="auth-name-input"/>
            </div>
          )}
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--text-3)]" size={16}/>
            <input type="email" className="input pl-9" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} required data-testid="auth-email-input"/>
          </div>
          {mode === "register" && (
            <div className="relative">
              <Phone className="absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--text-3)]" size={16}/>
              <input type="tel" className="input pl-9" placeholder="Telemóvel (ex: +351 912345678)" value={phone} onChange={e=>setPhone(e.target.value)} required minLength={9} data-testid="auth-phone-input"/>
            </div>
          )}
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--text-3)]" size={16}/>
            <input type="password" className="input pl-9" placeholder="Password (mín. 6)" value={password} onChange={e=>setPassword(e.target.value)} required minLength={6} data-testid="auth-password-input"/>
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full flex items-center justify-center gap-2" data-testid="auth-submit-btn">
            <LogIn size={16}/> {busy ? "..." : (mode === "login" ? "Entrar" : "Criar conta")}
          </button>
        </form>

        <p className="text-center text-sm text-[color:var(--text-2)] mt-6">
          {mode === "login" ? "Ainda não tens conta?" : "Já tens conta?"}{" "}
          <button onClick={() => setMode(mode === "login" ? "register" : "login")} className="text-gold underline" data-testid="auth-mode-toggle">
            {mode === "login" ? "Criar conta" : "Entrar"}
          </button>
        </p>
      </div>
    </div>
  );
}
